import React, { useState } from "react";
import { Control, actions } from "react-redux-form";
import { Row, Col, Button } from "reactstrap";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import {
  FormGroup,
  DatePicker,
  SubmitButton,
  withLocalForm,
  XeroAutoComplete,
} from "components/common";
import Select from "react-select";
import { Trans, withTranslation } from "react-i18next";
import { ALL } from "./constants/statuses";

export const Search = ({
  LocalForm,
  handleSubmit,
  searchWithinOptions,
  handleClear,
  dispatch,
  t,
  contactID,
}) => {
  
    const [contactKey, setContactKey] = useState(0);
    const clearContact = () => {
      dispatch(actions.reset('local.contactIDs'));

      setContactKey(prevKey => parseInt(prevKey) + 1);
    };

  return (
    <LocalForm onSubmit={handleSubmit}>
      <div className="d-inline-block">
        <Row className="small mb-3">
          <Col xs="auto">
            <FormGroup
              label="Enter Quote Number"
              className="text-nowrap"
              model=".quoteNumber"
            >
              <Control.text className="form-control" model=".quoteNumber" />
            </FormGroup>
          </Col>
          <Col xs="auto">
            <FormGroup
              model=".contactID"
              label={t("Filter by Contact")}
            >

              <XeroAutoComplete
                key={contactKey}
                model=".contactID"
                value={contactID || ''}
                multi={false}
                onChange={(e) => dispatch(actions.change('local.contactID', e && e.ContactID))}
                valueKey={'ContactID'}
                labelKey={"Name"}
                url="contacts"
                placeholder={t('Select...')}
                searchPromptText={t('Type to search')}
                
              />

            </FormGroup>
          </Col>
          <Col xs="auto">
            <FormGroup
              label="Search Within"
              addControlClass={false}
              className="text-nowrap" 
            >
              <Control.text
                component={Select}
                style={{ minWidth: "10rem",backgroundColor:'#F4F7FE'}}
                model=".searchWithin"
                simpleValue
                clearable={false}
                options={searchWithinOptions}
              />
            </FormGroup>
          </Col>
          <Col xs="auto">
            <FormGroup label="Start" className="text-nowrap">
              <DatePicker
                className="form-control form-control-sm"
                model=".startDate"
              />
            </FormGroup>
          </Col>
          <Col xs="auto">
            <FormGroup label="End">
              <DatePicker
                className="form-control form-control-sm"
                model=".endDate"
              />
            </FormGroup>
          </Col>
            <div
              className="mb-2 mt-4 d-flex justify-content-center align-items-center">
            
            <Button className="btn-sm btn-clear btn-danger" onClick={() => { handleClear(); clearContact(); }} style={{color:'#fff' }}>
                <Trans>Clear</Trans>
              </Button>
              <div className="mx-1" />
              <SubmitButton className="btn-sm">Search</SubmitButton>
            </div>
        
        </Row>
        </div>
      
    </LocalForm>
)};

export const enhance = compose(
  withLocalForm({
    initialState: {
      quoteNumber: "",
      searchWithin: "datecreated",
      startDate: null,
      endDate: null,
      contactID: null,
    },
  }),
  withTranslation(),
  withPropsOnChange(["language"], ({ t, invoice }) => {
    return {
      searchWithinOptions: [
        {
          label: t("Date created"),
          value: "datecreated",
        },
        {
          label: t("Expiry date"),
          value: "expirydate",
        },
      ],
    };
  }),
  withHandlers({
    handleSubmit:
      ({ status, onFiltersChanged }) =>
      (search) => {
        const filters = {
          Status: status === ALL ? undefined : status,
        };

        const { quoteNumber, startDate, endDate, searchWithin, contactID } = search;

        if (quoteNumber) {
          filters.QuoteNumber = quoteNumber;
        }

        if (contactID) {
          filters.ContactID = contactID;
        }

        if (startDate || endDate) {
          switch (searchWithin) {
            case "datecreated":
              if (startDate) {
                filters.DateFrom = startDate;
              }
              if (endDate) {
                filters.DateTo = endDate;
              }
              break;
            case "expirydate":
              if (startDate) {
                filters.ExpiryDateFrom = startDate;
              }
              if (endDate) {
                filters.ExpiryDateTo = endDate;
              }
              break;
            default:
              break;
          }
        }

        onFiltersChanged({
          extra_params: {
            ...filters,
          },
        });
      },
    handleClear:
      ({ dispatch, onFiltersChanged }) =>
      () => {
        dispatch(actions.reset("local"));
        onFiltersChanged(null);
      },
  })
);

export default enhance(Search);
